import React, { useState, useEffect } from 'react';
import { cn } from '../lib/utils';
import { Skeleton } from './ui/skeleton';

const SmartImage = ({ src, alt, className, containerClassName }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!src) return;
    
    const img = new Image();
    img.src = src;
    img.onload = () => setLoaded(true);
    img.onerror = () => {
      setLoaded(true);
      setError(true);
    };
  }, [src]);

  return (
    <div className={cn("relative overflow-hidden", containerClassName)}>
      {!loaded && (
        <Skeleton className="absolute inset-0 w-full h-full rounded-none" />
      )}
      
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={cn(
          "w-full h-full object-cover transition-all duration-500",
          !loaded ? "opacity-0 scale-105" : "opacity-100 scale-100",
          error && "opacity-20 grayscale",
          className
        )}
      />
      
      {error && (
        <div className="absolute inset-0 flex items-center justify-center bg-neutral-100 text-neutral-400 text-[10px] uppercase tracking-tighter text-center p-2">
          Image not found
        </div>
      )}
    </div>
  );
};

export default SmartImage;
